export default __webpack_public_path__ + "static/cellar-454e31b78b42570a7232cc80aed9c03e.gif";